var _circle, _circle2, _circle3, _circle4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerified = function SvgVerified(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64,
    r: 62,
    fill: "#81E1FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64,
    r: 62,
    fill: "url(#paint0_linear_15538_292793)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64,
    r: 62,
    stroke: "#fff",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 121,
    height: 120
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64,
    r: 60,
    fill: "#6B0707"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_15538_292793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 40l5.506-1.573a72.997 72.997 0 0016.164-6.81L62.5 28l6.33 3.617a72.997 72.997 0 0016.164 6.81L90.5 40v25.143a33 33 0 01-16.246 28.43l-10.23 6.03a3.002 3.002 0 01-3.047 0l-10.23-6.03A33 33 0 0134.5 65.144V40z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.95 38.077l-1.45.414v26.652a35 35 0 0017.23 30.154l10.232 6.029a5 5 0 005.076 0l10.231-6.03A35 35 0 0092.5 65.144V38.49l-1.45-.414-5.507-1.573a71 71 0 01-15.72-6.623l-6.33-3.617-.993-.567-.992.567-6.33 3.617a71 71 0 01-15.721 6.623l-5.506 1.573z",
    stroke: "#38A3AC",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.5 41l-4-4v4h4z",
    fill: "#20656C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 72l-2.828 2.828L60 77.657l2.828-2.829L60 72zm18.828-13.172L81.657 56 76 50.343l-2.828 2.829 5.656 5.656zm-31.656 6l10 10 5.656-5.656-10-10-5.656 5.656zm15.656 10l16-16-5.656-5.656-16 16 5.656 5.656z",
    fill: "#38A3AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15538_292793",
    x1: 4.5,
    y1: 4,
    x2: 124.5,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC198",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC198",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_15538_292793",
    x: 30.5,
    y: 23.393,
    width: 68,
    height: 84.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101961 0 0 0 0 0.364706 0 0 0 0 0.301961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15538_292793"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101961 0 0 0 0 0.364706 0 0 0 0 0.301961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_15538_292793",
    result: "effect2_dropShadow_15538_292793"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101961 0 0 0 0 0.364706 0 0 0 0 0.301961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_15538_292793",
    result: "effect3_dropShadow_15538_292793"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101961 0 0 0 0 0.364706 0 0 0 0 0.301961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_15538_292793",
    result: "effect4_dropShadow_15538_292793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_15538_292793",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "verified.b736f79f4131fe51401491745710351a.svg";